'use client';

import Image from 'next/image';
import React, { memo, useRef } from 'react';
import {
	NavigationMenu,
	NavigationMenuContent,
	NavigationMenuItem,
	NavigationMenuList,
	NavigationMenuTrigger,
	NavigationMenuViewport,
} from '@/components/ui/navigation-menu';
import { components } from '@/types/strapi';
import ProductMenu from './menu-sections/product-menu';

export const DesktopNavigation = memo(function DesktopNavigation({
	megamenu,
}: {
	megamenu: components['schemas']['GlobalMegamenuComponent'][];
}) {
	const navigationMenuRef = useRef<HTMLDivElement>(null);
	const handleLinkClick = () => {
		// Find and click the trigger to close the menu
		const openTrigger = navigationMenuRef.current?.querySelector(
			'[data-state="open"]',
		) as HTMLButtonElement;
		if (openTrigger) {
			openTrigger.click();
		}
	};
	return (
		<NavigationMenu
			ref={navigationMenuRef}
			className="mx-auto hidden xl:flex">
			<NavigationMenuList className="gap-1">
				{megamenu?.map((item, index) => (
					<NavigationMenuItem key={index}>
						<NavigationMenuTrigger className="menu-trigger group h-10 bg-white px-2.5 transition-colors focus:bg-gray-50 data-[state=open]:bg-gray-50 data-[state=open]:text-primary min-[1440px]:px-4">
							<span className="flex items-center gap-1.5 group-data-[state=open]:text-blue-500">
								{item.icon && item.icon.url && (
									<Image
										src={item.icon.url}
										alt={'alt'}
										width={20}
										height={20}
										className="hidden h-4 w-4 text-primary group-data-[state=open]:text-primary min-[1440px]:block"
									/>
									// renderIcon(
									// 	item.icon,
									// 	'h-4 w-4 text-primary group-data-[state=open]:text-primary',
								)}

								{item.name}
							</span>
						</NavigationMenuTrigger>
						<NavigationMenuContent
							className="z-50"
							onClick={handleLinkClick}>
							{/* {item.submenu && (
									<div className="w-[min(900px,90vw)] p-1 backdrop-blur-sm">
										{renderMenuContent(item)}
									</div>
								)} */}
							{item.submenu && item.icon && (
								<div className="w-[min(900px,90vw)] p-1 backdrop-blur-sm">
									<ProductMenu
										item={
											item.submenu as components['schemas']['ItemsSubmenuContentComponent'][]
										}
										name={item.name || 'Name'}
										icon={item.icon}
									/>
								</div>
							)}
						</NavigationMenuContent>
					</NavigationMenuItem>
				))}
			</NavigationMenuList>
			<NavigationMenuViewport />
		</NavigationMenu>
	);
});

// /**
//  * Renders the appropriate menu content based on the menu item name
//  */
// function renderMenuContent(item: MenuItem) {
// 	switch (item.name) {
// 		case 'Solution':
// 			return <SolutionsMenu item={item} />;
// 		// case 'Products':
// 		// 	return <ProductMenu item={item} />;
// 		case 'Developer Tools':
// 			return <DeveloperToolsMenu item={item} />;
// 		case 'Pricing':
// 			return <PricingMenu item={item} />;
// 		case 'Resources':
// 			return <ResourcesMenu item={item} />;
// 		case 'Company':
// 			return <CompanyMenu item={item} />;
// 		default:
// 			return <StandardMenuContent item={item} />;
// 	}
// }
